import { useCallback } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { useTheme } from '../contexts/ThemeContext';
import { updateUserInfo } from '../features/user/userSlice';
import axiosWrapper from '../utils/apiRequests/axiosWrapper';

/**
 * Toggles the app theme and persists the preference for logged-in users.
 * Shared by the navbar button and the command palette so the persistence
 * logic lives in one place.
 */
const useThemeToggle = () => {
  const dispatch = useDispatch();
  const user = useSelector((state) => state.user.userInfo);
  const { toggleCurrentTheme } = useTheme();

  return useCallback(() => {
    const newTheme = toggleCurrentTheme();

    if (user?._id) {
      dispatch(updateUserInfo({ theme: newTheme }));

      // Persist in the background; the UI already shows the new theme.
      axiosWrapper({
        method: 'put',
        path: 'users/settings/preferences',
        data: { theme: newTheme, dailyWordGoal: user?.dailyWordGoal || 500 },
      }).catch((err) => {
        console.error('Error updating theme preference:', err);
      });
    }

    return newTheme;
  }, [dispatch, toggleCurrentTheme, user?._id, user?.dailyWordGoal]);
};

export default useThemeToggle;
